import { Dispatch } from 'redux';
import DONATE_PAGE_TYPES, { getDonatePageProps } from './types';
import API_ROUTES from 'services/apiRoutes';
import { oathApi } from 'services/oathApi';

export const getDonatePage =
  ({ urlPartner }: getDonatePageProps) =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch(DONATE_PAGE_TYPES.donatePageStart());

    try {
      const response = await oathApi.get(API_ROUTES.GET_DONATE_PAGE(urlPartner));
      if (!response.data?.pages?.[0]) {
        throw new Error('No page found');
      }
      dispatch(DONATE_PAGE_TYPES.donatePageSuccess(response.data.pages[0]));
      return Promise.resolve(response);
    } catch (error: any) {
      dispatch(DONATE_PAGE_TYPES.donatePageError(error.message));
      return Promise.reject(error);
    }
  };
